import React from 'react'
import Modal from 'react-modal';
import {locale} from '../locale/AppLocale'
import axios from 'axios'
import Config from '../Helpers/Config'

import {connect} from 'react-redux'
import {check,requiresRelogin} from '../actions/authActions'
import {NotificationManager} from '../Helpers/NotificationManager';
import Loader from '../Components/Loader'
import {GetEntityAttribute} from "../Helpers/Entity";

const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content: {
        overflow: '',
        top: '',
        left: '',
        right: '',
        bottom: '',
        marginRight: '',
        transform: '',
        padding: '',
        border: '',
        background: '',
        borderRadius: '',
    }
};

class EmailConfirm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        return (
            <div>
                <div className="shooq-modal--box">
                    <div className="shooq-modal--header">
                        <div className="shooq-modal--header--title text-center">{locale.get('your_store_account_has_not_been_approved_yet',{store_name: GetEntityAttribute(this.props.auth.business,'name')})}</div>
                    </div>
                    <div className="clearfix"></div>

                </div>
            </div>
        );
    }

}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    checkAuth: () => dispatch(check()),
    requiresReLogin: ()=>dispatch(requiresRelogin(true,true))
});
export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirm);
